import React from "react";
import ConfirmationModal from "app/components/common/ConfirmationModal";

const COPY = {
  send: {
    title: "Send Payment Request",
    confirmLabel: "Send Request",
    loadingLabel: "Sending",
    lines: ({ amount, clientName }) => [
      amount ? (
        <>
          Your client will receive a payment link for <strong>{amount}</strong>.
        </>
      ) : (
        "Your client will receive a payment link."
      ),
      clientName ? (
        <>
          A payment request email will be sent to <strong>{clientName}</strong>.
        </>
      ) : (
        "A payment request email will be sent to your client."
      ),
    ],
  },
  connect: {
    title: "Payment connection required",
    confirmLabel: "View Connection",
    lines: () => [
      <>
        To send payment requests, check your payment account in Payment
        Connection.
      </>,
    ],
  },
  markPaid: {
    title: "Mark as Paid",
    confirmLabel: "Mark as Paid",
    loadingLabel: "Saving",
    lines: ({ amount }) => [
      amount ? (
        <>
          Record a payment of <strong>{amount}</strong> received outside of
          Stripe, such as cash.
        </>
      ) : (
        "Record a payment received outside of Stripe, such as cash."
      ),
    ],
  },
  undo: {
    title: "Undo manual payment?",
    confirmLabel: "Undo",
    loadingLabel: "Undoing",
    cancelLabel: "Keep",
    lines: () => [
      "This payment will return to No Payment.",
      "You can send a payment request or mark as paid again.",
    ],
  },
  restart: {
    title: "Restart payment?",
    confirmLabel: "Start New",
    loadingLabel: "Clearing",
    lines: () => [
      "This will return to No Payment.",
      "You can then send a payment request or mark as paid manually.",
    ],
  },
  // Keep is the primary button: cancelling kills a link the client may
  // already be looking at, so the safe choice gets the emphasis.
  cancel: {
    title: "Cancel this payment request?",
    confirmLabel: "Cancel Request",
    loadingLabel: "Cancelling",
    confirmVariant: "outline-danger",
    cancelLabel: "Keep",
    cancelVariant: "primary",
    lines: () => [
      "The payment link will stop working immediately.",
      "This payment will return to No Payment.",
      "Remember to notify your client.",
    ],
  },
};

const PaymentConfirmModal = ({
  kind,
  amount,
  clientName,
  onHide,
  onConfirm,
  isLoading = false,
}) => {
  const copy = COPY[kind];

  return (
    <ConfirmationModal
      show={Boolean(copy)}
      onHide={onHide}
      onConfirm={onConfirm}
      title={copy?.title}
      confirmLabel={copy?.confirmLabel}
      confirmVariant={copy?.confirmVariant || "primary"}
      cancelLabel={copy?.cancelLabel}
      cancelVariant={copy?.cancelVariant}
      isLoading={isLoading}
      loadingLabel={copy?.loadingLabel}
      staticWhileLoading
    >
      {copy?.lines({ amount, clientName }).map((line, index) => (
        <p key={index} className="mb-0">
          {line}
        </p>
      ))}
    </ConfirmationModal>
  );
};

export default PaymentConfirmModal;
